import React, { useContext } from 'react';
import { Form as AntdForm, Space } from 'antd';
import styled from 'styled-components';
import { ApplicationUIContext } from '../Provider/Provider';

const StyledForm = styled(AntdForm)`
  > .ant-space {
    width: 100%;
  }

  .ant-form-item .ant-picker {
    width: 100%;
  }
`;

const FormRowSpace = styled(Space)`
  width: 100%;

  > * {
    width: 100%;
    flex: 1;
  }
`;

const Form = ({ gap = 8, children, ...props }) => {
  const { isMobile } = useContext(ApplicationUIContext);

  return (
    <StyledForm {...props} size={isMobile && 'large'}>
      <Space direction={props.layout || 'vertical'} size={gap}>
        {children}
      </Space>
    </StyledForm>
  );
};

const FormRow = (props) => {
  const { isMobile } = useContext(ApplicationUIContext);

  return (
    <FormRowSpace
      direction={isMobile ? 'vertical' : 'horizontal'}
      align="start"
      {...props}
    ></FormRowSpace>
  );
};

Form.Row = FormRow;

Form.Item = AntdForm.Item;
Form.List = AntdForm.List;
Form.ErrorList = AntdForm.ErrorList;
Form.Provider = AntdForm.Provider;
Form.useForm = AntdForm.useForm;
Form.useFormInstance = AntdForm.useFormInstance;
Form.useWatch = AntdForm.useWatch;

export { Form };
